import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { SectionDetailHeader } from './SectionDetailHeader';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { SmartGridView } from '../../components/GridView/SmartGridView';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { ShowTeaser } from '../../components/Teaser/ShowTeaser/ShowTeaser';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowSectionDetail = ({
  sectionDetail
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(SectionDetailHeader, {
    sectionDetail: sectionDetail
  }), /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsx(PlayContainer, {
      children: /*#__PURE__*/_jsx(SmartGridView, {
        canLoadMore: false,
        children: sectionDetail.data?.map((show, index) => /*#__PURE__*/_jsx(ShowTeaser, {
          show: show,
          index: index
        }, show.id))
      })
    })
  })]
});
const Layout = styled.div.withConfig({
  displayName: "ShowSectionDetail__Layout",
  componentId: "sc-bzcomc-0"
})(["margin-top:24px;", "{margin-top:40px;}"], Viewports.for('largeUp'));